import { Form } from 'react-final-form';
import { endOfToday } from 'date-fns';
import style from '../../styles/Reports.module.scss';
import { DateRangeField } from '../Field';
import { invalidFormAlert, normalizeFormValues } from '../../utils/Helpers';
import { getUserTimezone } from '../../utils/ReportsHelpers';
import { validateTimezone, validateDate, validateDateTime, validateDateRange } from '../../utils/Validation';

function ControlPanel({
  onSubmit,
  searchOnCooldown,
  loading,
  report,
  roundRightCorners = true,
  startDate,
  endDate,
  timezone,
  minDate = undefined,
  includeTimeValues = false,
  includeTimezone = false,
  maxRangeDays = 365, // One year by default
  labelStart,
  labelEnd,
}) {
  const buildSearch = (values) => ({
    startDate: !includeTimeValues && values.dateTimeStart ?
      `${values.dateTimeStart} 00:00` : values.dateTimeStart,
    endDate: !includeTimeValues && values.dateTimeEnd ?
      `${values.dateTimeEnd} 23:59` : values.dateTimeEnd,
    timezone: includeTimezone ? values.timezone : getUserTimezone(),
  });

  function validate(values) {
    normalizeFormValues(values);
    const errors = {};

    // Validate dateTimeStart and dateTimeEnd
    const validateDateFunc = includeTimeValues ? validateDateTime : validateDate;
    errors.dateTimeStart = validateDateFunc(values.dateTimeStart);
    errors.dateTimeEnd = validateDateFunc(values.dateTimeEnd);

    // Validate dateTimeStart and dateTimeEnd ranges
    if (!errors.dateTimeStart && !errors.dateTimeEnd) {
      const { dateTimeStart, dateTimeEnd } = values;
      const startDateRange = includeTimeValues ? dateTimeStart : `${dateTimeStart} 00:00`;
      const endDateRange = includeTimeValues ? dateTimeEnd : `${dateTimeEnd} 23:59`;
      errors.dateTimeStart = validateDateRange(startDateRange, endDateRange, maxRangeDays);
      errors.dateTimeEnd = errors.dateTimeStart;
    }

    // Validate timezone for payment reports
    if (includeTimezone) errors.timezone = validateTimezone(values.timezone);

    return errors;
  }

  return (
    <Form
      onSubmit={(values) => onSubmit(buildSearch(values))}
      validate={(values) => validate(values)}
      render={({
        handleSubmit,
        invalid,
        errors,
        submitErrors,
        submitting,
        form,
        touched,
      }) => (
        <form
          onSubmit={(event) => {
            invalidFormAlert(invalid, errors);
            handleSubmit(event);
          }}
          className={`${includeTimezone ? style.controlPanelForm : style.controlPanelFormSmall} 
          ${roundRightCorners ? style.controlPanelRightRounded : ''}`}
        >

          <DateRangeField
            idStart="StartTimeInput"
            idEnd="EndTimeInput"
            labelStart={labelStart}
            labelEnd={labelEnd}
            errors={errors}
            submitErrors={submitErrors}
            touched={touched}
            includeTime={includeTimeValues}
            nameStart="dateTimeStart"
            nameEnd="dateTimeEnd"
            setValue={form.change}
            maxDate={endOfToday()}
            minDate={minDate}
            initialStartValue={startDate}
            initialEndValue={endDate}
            contClassName={style.dateRangeCont}
            includeTimezone={includeTimezone}
            timezone={timezone}
            submitting={submitting}
            loading={loading}
            report={report}
            searchOnCooldown={searchOnCooldown}
            buildSearch={buildSearch}
            form={form}
          />
        </form>

      )}
    />
  );
}

export default ControlPanel;
